import styled from '@emotion/styled'
import { stylesIf, themeColor } from 'utils/styles'

import { PageHeader as AntPageHeader } from 'antd'
import { TextArea } from 'components/patterns/Inputs'
import Button from 'components/patterns/Button'
import { DrawerRow } from 'components/patterns/Drawer/Drawer.style'

export const DrawerHeader = styled.div`
  display: flex;
  background-color: ${themeColor('blueSecondary')};
  color: ${themeColor('whitePrimary')};
  width: 100%;
  font-size: 1rem;
  padding: 0.45rem 0.6rem;
  gap: 4px;
  align-items: center;
`

export const StyledDrawerHeaderButton = styled(Button)`
  margin: 0 0 0 8px !important;
  height: 24px !important;
`

export const PageHeader = styled(AntPageHeader)`
  border: 1px solid ${themeColor('greySecondary')};
  background-color: ${themeColor('whitePrimary')};
`

export const PageContent = styled.div`
  background-color: ${themeColor('modalGrey')};
  height: 100%;
`

export const StyledNotificationWrapper = styled.div`
  padding: 16px;
`

export const ModuleWrapper = styled.div`
  display: flex;
  margin-top: 45px;
  justify-content: center;
  gap: 16px;
`

export const ModuleCard = styled.div((props) => {
  const { type } = props
  const isOutlined = type === 'outlined'

  return `
   width: 132px;
    height: 152px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 16px 8px;
    border-radius: 8px;
    border: thin dashed ${themeColor('greyPrimary', props)};
    cursor: pointer;
    color: ${themeColor('bluePrimary', props)};
    position: relative;
    ${stylesIf(
      !isOutlined,
      `
      border: 0;
      background-color: ${themeColor('whitePrimary', props)};
      box-shadow: 0 0.8px 4.1px 0 ${themeColor('blackPrimaryShadow', props)};
    `
    )};
  `
})

export const ModuleCardHeader = styled.div((props) => {
  const { children } = props
  return `
  font-family: Arial;
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: normal;
  color: ${themeColor('blackSecondary', props)};
  ${stylesIf(
    typeof children !== 'string' && children.length > 1,
    `
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  `
  )};
  
`
})

export const ModuleGraphic = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Divider = styled.hr`
  height: 152px;
  display: flex;
  width: 1px;
  background-color: ${themeColor('grey')};
  margin: 0;
  border: 0;
`

export const PlusSign = styled.span`
  width: 29px;
  height: 24px;
  flex-grow: 0;
  font-family: Arial;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.5;
  letter-spacing: normal;
  text-align: center;
  color: ${themeColor('bluePrimary')};
`

export const RemoveModuleBtn = styled.button(({ disabled }) => {
  return `
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 0;
  box-shadow: none;
  background: transparent;
  padding: 0;

  ${stylesIf(
    disabled,
    `
   opacity: 0.2
  `
  )};
`
})

export const RemoveIconElement = styled.img`
  width: 20px;
  height: 20px;
`

export const NewXMCModuleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const StatusPill = styled.img`
  width: 70px;
  height: 17px;
`

export const StyledTextArea = styled(TextArea)`
  max-width: 439px;
  margin: 28px auto 0;
  & textarea {
    height: 100px;
  }
`

export const FooterStyled = styled(DrawerRow)`
  width: 100%;
  border-top: 1px solid ${themeColor('greySecondary')};
  padding-top: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: ${themeColor('whitePrimary')};
  text-align: center;
`.withComponent('footer')
